export const OBJETIVO_PRODUTOR_ENUM = [
    {
        id: 'REDUZIR_CUSTO',
        descricao: "Reduzir custos de produção",
    },
    {
        id: 'EMITIR_NFE',
        descricao: "Emitir Notas Fiscais",
    },
    {
        id: 'CONTROLE_FINANCEIRO',
        descricao: "Melhorar controle financeiro",
    },
    {
        id: 'ORGANIZAR_ATV_CAMPO',
        descricao: "Organizar minhas atividades de campo",
    },
    {
        id: 'CONTROLE_MAQ',
        descricao: "Controlar as revisões e custos de maquinários",
    },
    {
        id: 'CONTROLE_ESTOQUE',
        descricao: "Ter controle de estoque",
    },
    // {
    //     id: 'LIVRO_CAIXA',
    //     descricao: "Reduzir impostos a pagar e gerenciar o Livro Caixa",
    // },
    // {
    //     id: 'GERENCIAR_CONTRATOS_FUTUROS',
    //     descricao: "Gerenciar contratos futuros e preços de venda",
    // },
    {
        id: 'OUTRO',
        descricao: "Outro (especificar)",
    },
];

